import React from 'react';
import { Box, Divider, Paper, Tooltip, Typography } from '@mui/material';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import CustomComposedChart from '../../../components/customComposedChart/CustomComposedChart';
import Loading from '../../../components/loading/Loading';
import { IndicadorChart } from '../IndicadoresGraficos.types';
import { PeriodoFiltro } from '../IndicadoresGraficos.loaders';

const GRANULARIDADE_LABEL: Record<PeriodoFiltro, string> = {
  ultima_semana: 'Por dia',
  ultimo_mes: 'Por dia',
  ultimos_3_meses: 'Por semana',
  ultimos_6_meses: 'Por mês',
  ultimos_12_meses: 'Por mês',
};

type PedidosPeriodoChartCardProps = {
  isLoading: boolean;
  dados: IndicadorChart[];
  periodo: PeriodoFiltro;
};

function PedidosPeriodoChartCard({
  isLoading,
  dados,
  periodo,
}: PedidosPeriodoChartCardProps) {
  const granularidade = GRANULARIDADE_LABEL[periodo];
  return (
    <Paper elevation={0} className='indicadores-paper indicadores-chart-paper'>
      <Box className='indicadores-chart-header'>
        <Box>
          <Typography className='indicadores-chart-title'>Pedidos por período</Typography>
          <Typography className='indicadores-chart-subtitle'>
            Pedidos realizados no período selecionado.{' '}
            <Tooltip title='Agrupamento dos dados no eixo X' arrow>
              <span style={{ fontStyle: 'italic', cursor: 'default' }}>{granularidade}</span>
            </Tooltip>
          </Typography>
        </Box>
      </Box>

      <Box className='indicadores-status-bar-spacer' />
      <Divider className='indicadores-divider' />

      {isLoading ? (
        <Loading />
      ) : dados.length === 0 || dados.every((d) => d.qtdPedidos === 0) ? (
        <Box className='indicadores-empty-state'>
          <Box>
            <QueryStatsRoundedIcon className='indicadores-empty-icon' />
            <Typography className='indicadores-empty-title'>
              Nenhum pedido encontrado para o período selecionado.
            </Typography>
            <Typography className='indicadores-empty-description'>
              Ajuste o intervalo de datas e clique em Atualizar.
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box className='indicadores-chart-wrap'>
          <CustomComposedChart
            data={dados}
            xDataKey='data'
            barDataKey='qtdPedidos'
            barName='Qtd. Pedidos'
            barColor='#2f9cf5'
          />
        </Box>
      )}
    </Paper>
  );
}

export default PedidosPeriodoChartCard;
